import { HANA_CLIENT_INFO, configFromClientInfo, createWorkCalendar, type ClientInfoRow } from '@hana/work-calendar';
import type { MeeAttendance, MeePerson, MeeRequest } from './types';

/** Ngày "hôm nay" của board Mint-Mee. */
export const BOARD_TODAY = '2026-10-22';
/** Giờ hiện tại của board. */
export const BOARD_NOW = '15:20';
/** Phép năm tính từ ngày này (như board) */
export const LEAVE_YEAR_FROM = '2026-09-01';

/** tblClientInfo mẫu cho Mee: cột lịch của HANA + ngày lễ của board. App thật đọc từ worker `api`. */
export const MEE_CLIENT_INFO: ClientInfoRow = {
  ...HANA_CLIENT_INFO,
  Holidays: [
    '2026-09-01..2026-09-02 Quốc khánh',
    '2026-12-26 Tất niên #cty',
    '2027-01-01 Tết Dương lịch',
    '2027-02-05..2027-02-11 Tết Nguyên đán',
  ].join('\n'),
};

export const meeCalendar = () => createWorkCalendar(configFromClientInfo(MEE_CLIENT_INFO));

const member = (id: string, dept: string, title: string, joined: string, used: number): MeePerson => ({
  id, name: id, initials: id.slice(0, 2).toUpperCase(), dept, seats: [[`${dept === 'Kinh doanh' ? 'SALE' : 'CSD'}-STF`, title, 'Primary']],
  manager: false, joined, route: [['SALE-MGR', 'DAVID', 'Cấp trên trực tiếp'], ['HRD-MGR', 'HANHLTM', 'HC–NS ghi nhận vào bảng công · kiêm nhiệm']],
  team: [], leaveUsedBase: used, leaveByMonth: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], contract: 'HĐLĐ không xác định thời hạn',
});

export const PEOPLE: readonly MeePerson[] = [
  {
    id: 'DAVID', name: 'Nguyễn Trường Giang', initials: 'DV', dept: 'Kinh doanh',
    seats: [['SALE-MGR', 'Trưởng phòng Kinh doanh', 'Primary'], ['BOD-DDIR', 'Phó Giám đốc', 'Acting']],
    manager: true, joined: '2019-03-04',
    route: [['BOD-DIR', 'PHILIP', 'Cấp trên trực tiếp'], ['HRD-MGR', 'HANHLTM', 'HC–NS ghi nhận vào bảng công · kiêm nhiệm']],
    team: ['TUANNT', 'ANDG', 'AnNPH', 'TRANGHDD'], leaveUsedBase: 4, leaveByMonth: [0, 1, 0, 1, 0, 0, 2, 0, 1, 0, 0, 0],
    contract: 'HĐLĐ không xác định thời hạn', bk: ['TUANNT', 'ANDG'],
  },
  {
    id: 'MAITTN', name: 'Trịnh Thị Ngọc Mai', initials: 'MA', dept: 'Dịch vụ khách hàng',
    seats: [['CSD-CSO', 'Nhân viên DVKH', 'Primary']],
    manager: false, joined: '2025-01-15',
    route: [['CSD-MGR', 'Ghế trống → PHILIP', 'Ghế CSD-MGR trống · lên [BOD-DIR] PHILIP'], ['HRD-MGR', 'HANHLTM', 'HC–NS ghi nhận vào bảng công · kiêm nhiệm']],
    team: [], leaveUsedBase: 6, leaveByMonth: [1, 0, 2, 0, 1, 0, 1, 1, 0, 0, 0, 0],
    contract: 'HĐLĐ xác định thời hạn 24 tháng', bk: ['HOATTN', 'ThuyNTT'],
  },
  member('TUANNT', 'Kinh doanh', 'Nhân viên Kinh doanh', '2022-05-09', 8),
  member('ANDG', 'Kinh doanh', 'Nhân viên Kinh doanh', '2023-02-13', 5.5),
  member('AnNPH', 'Kinh doanh', 'Nhân viên Kinh doanh', '2024-07-01', 3),
  member('TRANGHDD', 'Kinh doanh', 'Nhân viên Kinh doanh', '2024-11-18', 2),
];

export const REQUESTS: readonly MeeRequest[] = [
  { id: 'NP-2610-036', owner: 'DAVID', type: 'leave', sub: 'Phép năm', from: '2026-10-30', to: '2026-10-30', qty: 1, status: 'Pending', sent: '21/Oct/2026 16:05' },
  { id: 'OT-2610-014', owner: 'DAVID', type: 'ot', sub: 'Tăng ca', from: '2026-10-21', t0: '17:30', t1: '19:45', status: 'Pending', sent: '22/Oct/2026 08:10' },
  { id: 'CT-2610-005', owner: 'DAVID', type: 'trip', sub: 'Công tác Bình Dương', from: '2026-10-15', to: '2026-10-15', qty: 1, status: 'Approved', sent: '13/Oct/2026 10:20' },
  { id: 'GT-2610-003', owner: 'DAVID', type: 'fix', sub: 'Quên chấm ra', from: '2026-10-14', status: 'Pending', sent: '15/Oct/2026 08:02' },
  { id: 'NP-2610-021', owner: 'DAVID', type: 'leave', sub: 'Phép năm', from: '2026-10-16', to: '2026-10-16', qty: 0.5, half: 'AM', status: 'Approved', sent: '14/Oct/2026 09:40' },
  { id: 'NP-2610-012', owner: 'DAVID', type: 'leave', sub: 'Phép năm', from: '2026-10-09', to: '2026-10-09', qty: 1, status: 'Approved', sent: '06/Oct/2026 14:12' },
  { id: 'NP-2609-018', owner: 'DAVID', type: 'leave', sub: 'Phép năm', from: '2026-09-18', to: '2026-09-18', qty: 1, status: 'Approved', sent: '15/Sep/2026 11:30' },
  { id: 'NP-2609-011', owner: 'DAVID', type: 'leave', sub: 'Việc cá nhân', from: '2026-09-11', to: '2026-09-11', qty: 1, status: 'Cancelled', sent: '08/Sep/2026 08:44' },
  { id: 'NP-2610-028', owner: 'TRANGHDD', type: 'leave', sub: 'Phép năm', from: '2026-10-20', to: '2026-10-20', qty: 1, status: 'Approved', sent: '15/Oct/2026 10:05' },
  { id: 'NP-2610-030', owner: 'AnNPH', type: 'leave', sub: 'Phép năm', from: '2026-10-30', to: '2026-10-30', qty: 1, status: 'Approved', sent: '16/Oct/2026 14:20' },
  { id: 'NP-2610-031', owner: 'TUANNT', type: 'leave', sub: 'Phép năm', from: '2026-10-24', to: '2026-10-24', qty: 1, handover: 'ANDG', status: 'Pending', sent: '20/Oct/2026 09:12' },
  { id: 'NP-2610-033', owner: 'ANDG', type: 'leave', sub: 'Phép năm', from: '2026-10-27', to: '2026-10-28', qty: 2, handover: 'TUANNT', status: 'Pending', sent: '20/Oct/2026 11:30' },
  { id: 'OT-2610-012', owner: 'AnNPH', type: 'ot', sub: 'Tăng ca', from: '2026-10-21', t0: '17:30', t1: '20:00', status: 'Pending', sent: '22/Oct/2026 08:40' },
  { id: 'CT-2610-006', owner: 'TRANGHDD', type: 'trip', sub: 'Công tác Cái Mép', from: '2026-10-29', to: '2026-10-29', qty: 1, status: 'Pending', sent: '21/Oct/2026 08:15' },
  { id: 'NP-2610-034', owner: 'MAITTN', type: 'leave', sub: 'Phép năm', from: '2026-10-28', to: '2026-10-28', qty: 1, status: 'Pending', sent: '20/Oct/2026 15:10' },
  { id: 'OT-2610-011', owner: 'MAITTN', type: 'ot', sub: 'Tăng ca', from: '2026-10-20', t0: '17:30', t1: '19:00', status: 'Approved', sent: '21/Oct/2026 08:05' },
  { id: 'NP-2610-009', owner: 'MAITTN', type: 'leave', sub: 'Phép năm', from: '2026-10-06', to: '2026-10-06', qty: 1, status: 'Approved', sent: '02/Oct/2026 10:00' },
  { id: 'GT-2609-007', owner: 'MAITTN', type: 'fix', sub: 'Quên chấm ra', from: '2026-09-11', status: 'Rejected', sent: '12/Sep/2026 08:30' },
  { id: 'NP-2609-015', owner: 'MAITTN', type: 'leave', sub: 'Phép năm', from: '2026-09-25', to: '2026-09-25', qty: 1, status: 'Approved', sent: '22/Sep/2026 09:15' },
];

const att = (owner: string, day: string, inT: string, out: string, o: Pick<MeeAttendance, 'leave' | 'half'> = {}): MeeAttendance => ({
  id: `${owner}:${day}`, owner, day, in: inT, out, ...o,
});

export const ATTENDANCE: readonly MeeAttendance[] = [
  att('DAVID', '2026-10-06', '08:12', '17:35'),
  att('DAVID', '2026-10-09', '', '', { leave: true }),
  att('DAVID', '2026-10-14', '07:55', ''),
  att('DAVID', '2026-10-16', '13:10', '17:40', { half: true }),
  att('DAVID', '2026-10-21', '07:50', '19:45'),
  att('DAVID', '2026-09-18', '', '', { leave: true }),
  att('DAVID', '2026-09-23', '08:20', '17:32'),
  att('MAITTN', '2026-10-06', '', '', { leave: true }),
  att('MAITTN', '2026-10-13', '08:09', '17:31'),
  att('MAITTN', '2026-10-20', '07:48', '19:00'),
  att('MAITTN', '2026-09-11', '07:58', ''),
  att('MAITTN', '2026-09-25', '', '', { leave: true }),
];
